import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { useLanguageInitializer, useThemeInitializer } from './hooks';
import { PaymentType } from './api/payamigo';

import NotFound from './pages/notFound';
import PayAmigo from './pages/payAmigo';

const Router: React.FC = (): JSX.Element => {
  useThemeInitializer();
  useLanguageInitializer();

  return (
    <>
      <Routes>
        <Route
          path="/deposit"
          element={<PayAmigo paymentType={PaymentType.Deposit} />}
        />

        <Route
          path="/withdrawal"
          element={<PayAmigo paymentType={PaymentType.Withdrawal} />}
        />

        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </>
  );
};

export default Router;
